import { MOCK_DATA } from '../../local_modules/voyage-polar-plot/helper';
import { authFetchGET, authFetchPOST } from '../utils/auth-fetch'
import { POLAR_PLOT_MOCK_DATA_V3_MLModel, POLAR_PLOT_MOCK_DATA_V4 } from '../../local_modules/voyage-polar-plot/mock/polar-plots'

const routeOptimiserApi = (<any>window)["appenv"].services.routeoptimiserapi;
const isVesselOnCloud = (<any>window)["appenv"].vesselOnCloud;
const env = { ...routeOptimiserApi, ...isVesselOnCloud ? { scope: (<any>window)["appenv"].scope } : {} };

export const PolarPlotService = new (class extends EventTarget {
    async calculatePolarPlotData(payload: any): Promise<any> {
        // const res = POLAR_PLOT_MOCK_DATA_V3_MLModel
        const res = await authFetchPOST(env.scope, `${env.baseurl}/v1/polarplot/create`, payload, undefined, true);
        if (!res || typeof res !== 'object') {
            throw {
                error: 'Invalid response from Polar Plot Calculate API ',
                details: 'The response was not an object or was empty.',
                request: payload
            }
        }

        if (res.error) {
            throw res
        }
        return res
    }

    async reCalculatePolarPlotData(payload: any): Promise<any> {
        // const res = POLAR_PLOT_MOCK_DATA_V3_MLModel
           const res = await authFetchPOST(env.scope, `${env.baseurl}/v1/polarplot/recalculate`, payload, undefined, true);
            if (!res || typeof res !== 'object') {
                throw {
                    error: 'Invalid response from Polar Plot Recalculate API',
                    details: 'The response was not an object or was empty.',
                    request: payload
                }
            }

            if (res.error) {
                throw res
            }

        return res
    }

    async fetchImminentRiskPolarPlotData(log_id: number): Promise<any> {
        const res = await authFetchGET(env.scope, `${env.baseurl}/v1/polarplot/${log_id}`, undefined, undefined, true);

         //const res = POLAR_PLOT_MOCK_DATA_V3_MLModel;
        if (res.error) {
            throw res
        }
        return res
    }

    async fetchAuditLog(requestId: string): Promise<any> {
        const res = await authFetchGET(env.scope, `${env.baseurl}/v1/polarplot/audit-log/${requestId}`);
        if (res?.error) {
            throw res
        }
        return res
    }
})()
